import React from "react";
import { Link } from "react-router-dom";
import "../../styles/components/marketplace-shared.css";

const PageHero = ({
  eyebrow,
  title,
  description,
  className = "",
  stacked = false,
  linkBack = "",
  backLabel = "",
  children,
}) => {
  const classes = [
    "marketplace-page-hero",
    stacked ? "marketplace-page-hero--stacked" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes}>
      {eyebrow ? <span className="marketplace-page-hero__eyebrow">{eyebrow}</span> : null}
      {title ? <h1 className="marketplace-page-hero__title">{title}</h1> : null}
      {description ? <p className="marketplace-page-hero__description">{description}</p> : null}
      {linkBack && backLabel && 
          <Link to={linkBack} className="seller-back-link">
          <i className="fa fa-arrow-left m-r-8"></i>
          {backLabel}
        </Link>
      }
      {children}
    </section>
  );
};

export default PageHero;


